import React from 'react';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { CheckedIcon } from '@udacity/chakra-uds-icons';

import styles from './awaiting-approval.module.scss';

export const AwaitingApproval: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section className={styles['completed-container']}>
      <div className={styles['text-container']}>
        <h1 className={styles.completed}>
          <CheckedIcon w={10} h={10} />
          {t('mentorProfile.profileCompleted')}
        </h1>
        <div>
          <p className={styles.copy}>{t('mentorProfile.thanksForApplying')}</p>
          <NavLink className={styles['back-link']} to="/specialized-mentor/update">
            {t('mentorProfile.updateApplication')}
          </NavLink>
        </div>
      </div>
    </section>
  );
};
